import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Footer from "../components/Footer";
import About from "../components/About";

const AboutPage = () => {
    return (
        <div className="about-page-wrapper">
            <Helmet>
                <title>About Us | VNM Hitech Solutions</title>
                <meta name="description" content="Learn more about VNM Hitech Solutions, our mission, vision, and the team driving digital transformation in Karur." />
            </Helmet>
            <Header />
            <main style={{ paddingTop: '80px', minHeight: 'calc(100vh - 80px)' }}>
                <About />
            </main>
            <Footer />
        </div>
    );
};

export default AboutPage;
